import { render, staticRenderFns } from "./fb-instructions.vue?vue&type=template&id=24b5e42f&scoped=true&"
import script from "./fb-instructions.vue?vue&type=script&lang=ts&"
export * from "./fb-instructions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b5e42f",
  null
  
)

export default component.exports